import React, { useState, useEffect } from 'react'
import { MenuItem, Grid, TextField, FormHelperText, Button, InputAdornment } from '@material-ui/core';
import { Field, ErrorMessage } from 'formik';
import DatePicker from '../DatePicker';
import Observers from '../Observers';
import VisitService from '../../services/VisitService';
import Photos from '../Photos';
import { getErrorProps, getOptions, findPlot, observers } from '../../utils';
import ObjectDetails from './ObjectDetails';
import { useStore } from '../../Store'
import moment from 'moment';
import { Alert } from '@material-ui/lab';

const VisitDetails = ({ readonly, formik }) => {

  const { plots, settings } = useStore()
  const [openObjectInfo, setOpenObjectInfo] = useState(false)
  const [objectDefaults, setObjectDefaults] = useState()
  const [zomertelling, setZomertelling] = useState(false)

  const plotItems = () => {
    const arr = []
    const object = findPlot(plots, formik.values.plot);
    plots.filter(cluster => cluster.id === object.parentId).forEach(cluster => {
      cluster.children.forEach(obj => {
        arr.push(
          <MenuItem key={obj.id} value={obj.id}>
            {`${cluster.description} / ${obj.description}`}
          </MenuItem>
        )
      })
    })
    return arr
  }

  const updateDescription = (value) => {
    const description = (value && value.isValid() ? value.format('DD-MM-YYYY') : '')
    formik.setFieldValue('description', description)
  }

  const show = (name) => {
    const field = settings.visitFields.find(f => f.name === name)
    if (field && field.link && formik.values.extraInfo[field.link.name].match(field.link.matchPattern)) return true
    return false
  }

  const objectInfo = () => {
    if (!objectDefaults && moment(formik.values.dateStart).isValid()) {
      VisitService.getObjectInfo(formik.values.plot, formik.values.dateStart)
        .then(response => {
          const objectInfo = response.data
          settings.visitFields.filter(field => field.historic).forEach(field => {
            if (formik.initialValues.extraInfo[field.name] !== "") {
              objectInfo[field.name] = formik.initialValues.extraInfo[field.name]
            }
          })
          setObjectDefaults(response.data)
          formik.setFieldValue('objectInfo', { ...objectInfo })
          formik.initialValues['objectInfo'] = { ...objectInfo }
          setOpenObjectInfo(true)
        })
    } else {
      setOpenObjectInfo(true)
    }
  }

  useEffect(() => {
    const object = findPlot(plots, formik.values.plot);
    const cluster = findPlot(plots, object.parentId)
    if ('doel' in cluster.parent.extraInfo && cluster.parent.extraInfo['doel'] === 'zomer') {
      setZomertelling(true)
      telmethodeChanged({
        target: {
          name: 'extraInfo.telmethode', 
          value: (formik.values.id < 0?object.extraInfo['object_telmethode']:formik.values.extraInfo.telmethode)
        }
      })
    } else {
      setZomertelling(false);
    }
  }, [formik.values.plot, plots])

  const tellingtypeChanged = (e) => {
    console.log(`tellingtype naar ${e.target.value}`)
    if (e.target.value === 'regulier' && !formik.values.extraInfo.telmethode.match(/vliegroute|insitu|uitvlieg/)) {
      formik.setFieldValue('extraInfo.telmethode', 'uitvlieg')
    }
    formik.setFieldValue('extraInfo.trend', e.target.value === 'regulier' ? 'ja' : 'nee')
    formik.handleChange(e)
  }

  const telmethodeChanged = (e) => {
    let prtId
    switch (e.target.value) {
      case 'insitu':
        prtId = 5704
        break
      case 'vliegroute':
        prtId = 5705
        break
      case 'uitvlieg':
        prtId = 5706
        break
      default:
        prtId = 5701
    }
    formik.setFieldValue('prtId', prtId)
    formik.handleChange(e)
  }

  return (
    <Grid container>
      <Grid item xs={12}>
        <TextField select disabled={readonly} label="object" variant="standard" name="plot" fullWidth {...getErrorProps(formik, "plot")} {...formik.getFieldProps('plot')} >
          {plotItems()}
        </TextField>
      </Grid>

      <Grid item xs={12} >
        <Field disabled={readonly} label="bezoekdatum" variant="standard" name="dateStart" fullWidth {...getErrorProps(formik, "dateStart")} component={DatePicker}
          onChange={updateDescription} />
      </Grid>

      <Grid item xs={12} >
        <TextField disabled={readonly} label="duur (minuten)" variant="standard" name="duration" fullWidth {...getErrorProps(formik, "duration")} {...formik.getFieldProps('duration')} />
      </Grid>

      <Grid item xs={12} >
        <TextField disabled={readonly} label="opmerkingen" multiline variant="standard" name="extraInfo.opm_bezoek" type="number" fullWidth  {...getErrorProps(formik, "extraInfo.opm_bezoek")} {...formik.getFieldProps('extraInfo.opm_bezoek')} />
      </Grid>

      <Grid item xs={12} >
        <Field disabled={readonly} label="deelnemers" variant="standard" name="observers"
          options={observers(findPlot(plots, findPlot(plots, formik.values.plot).parentId), formik.values.roles)}
          fullWidth {...getErrorProps(formik, "observers")} component={Observers} />
        <FormHelperText error><ErrorMessage component="div" name="observers" /></FormHelperText>
      </Grid>

      {zomertelling &&
        <>
          <Grid item xs={12}>
            <Alert severity="info">
              NEM Zomertelling Meervleermuizen
            </Alert>
          </Grid>
          <Select name={"tellingtype"} label={"type telling"} formik={formik} disabled={readonly || formik.values.observations.filter(o => o.delstaId === 0).length > 0} lists={settings.lists} onChange={tellingtypeChanged} />
          <Select name={"telmethode"} label={"telmethode"} formik={formik} disabled={readonly || formik.values.observations.filter(o => o.delstaId === 0).length > 0}
            lists={settings.lists}
            filter={option => option.value.match(/vliegroute|insitu|uitvlieg/) || formik.values.extraInfo.tellingtype === 'precheck'}
            onChange={telmethodeChanged}
          />
          <Select name={"trend"} label={"gebruik voor trend?"} formik={formik} disabled={readonly} lists={settings.lists} />
          <Select name={"ndff"} label={"doorgeven aan ndff?"} formik={formik} disabled={readonly} lists={settings.lists} />
          {formik.values.extraInfo["telmethode"].match(/sporen|geluid|contact|zwermen|gevonden/) &&
            <Select name={"schatting"} label={"telling is schatting"} formik={formik} disabled={readonly} lists={settings.lists} />
          }
          {formik.values.extraInfo["telmethode"] === "sporen" &&
            <>
              <Select name={"sporen_middel"} label={"middelen"} formik={formik} disabled={readonly} lists={settings.lists} />
              {formik.values.extraInfo["sporen_middel"] === "anders" &&
                <Text name={"sporen_middel_anders"} label={"anders"} formik={formik} disabled={readonly} />
              }
              <Select name={"sporen_type"} label={"type"} formik={formik} disabled={readonly} lists={settings.lists} />
              {formik.values.extraInfo["sporen_type"] === "anders" &&
                <Text name={"sporen_type_anders"} label={"anders"} formik={formik} disabled={readonly} />
              }
              <Text name={"sporen_begintijd"} label={"begintijd"} formik={formik} disabled={readonly} type="time" placeholder="hh:mm" />
              <Text name={"sporen_eindtijd"} label={"eindtijd"} formik={formik} disabled={readonly} type="time" placeholder="hh:mm" />
            </>
          }
          {formik.values.extraInfo["telmethode"] === "zwermen" &&
            <>
              <Select name={"zwermen_middel"} label={"middelen"} formik={formik} disabled={readonly} lists={settings.lists} />
              {formik.values.extraInfo["zwermen_middel"] === "anders" &&
                <Text name={"zwermen_middel_anders"} label={"anders"} formik={formik} disabled={readonly} />
              }
              <Select name={"zwermen_type"} label={"type"} formik={formik} disabled={readonly} lists={settings.lists} />
              {formik.values.extraInfo["zwermen_type"] === "anders" &&
                <Text name={"zwermen_type_anders"} label={"anders"} formik={formik} disabled={readonly} />
              }
              <Text name={"zwermen_begintijd"} label={"begintijd"} formik={formik} disabled={readonly} type="time" placeholder="hh:mm" />
              <Text name={"zwermen_eindtijd"} label={"eindtijd"} formik={formik} disabled={readonly} type="time" placeholder="hh:mm" />
            </>
          }
          {formik.values.extraInfo["telmethode"] === "contact" &&
            <>
              <Select name={"contact_middel"} label={"middelen"} formik={formik} disabled={readonly} lists={settings.lists} />
              {formik.values.extraInfo["contact_middel"] === "anders" &&
                <Text name={"contact_middel_anders"} label={"anders"} formik={formik} disabled={readonly} />
              }
              <Text name={"contact_melding"} label={"beschrijving melding"} formik={formik} disabled={readonly} multiline />
            </>
          }
          {formik.values.extraInfo["telmethode"] === "gevonden" &&
            <>
              <Select name={"gevonden_middel"} label={"middelen"} formik={formik} disabled={readonly} lists={settings.lists} />
              {formik.values.extraInfo["gevonden_middel"] === "anders" &&
                <Text name={"gevonden_middel_anders"} label={"anders"} formik={formik} disabled={readonly} />
              }
              <Select name={"gevonden_toestand"} label={"toestand"} formik={formik} disabled={readonly} lists={settings.lists} />
              {formik.values.extraInfo["gevonden_toestand"] === "anders" &&
                <Text name={"gevonden_toestand_anders"} label={"anders"} formik={formik} disabled={readonly} />
              }
            </>
          }
          {formik.values.extraInfo["telmethode"] === "uitvlieg" &&
            <>
              <Select name={"uitvlieg_middel"} label={"middelen"} formik={formik} disabled={readonly} lists={settings.lists} />
              {formik.values.extraInfo["uitvlieg_middel"] === "anders" &&
                <Text name={"uitvlieg_middel_anders"} label={"anders"} formik={formik} disabled={readonly} />
              }
              <Text name={"uitvlieg_eerste"} label={"tijdstip eerste uitvlieger"} formik={formik} disabled={readonly} type="time" placeholder="hh:mm" />
              <Text name={"uitvlieg_laatste"} label={"tijdstip laatste uitvlieger"} formik={formik} disabled={readonly} type="time" placeholder="hh:mm" />
              <Text name={"uitvlieg_begintijd"} label={"begintijd"} formik={formik} disabled={readonly} type="time" placeholder="hh:mm" />
              <Text name={"uitvlieg_eindtijd"} label={"eindtijd"} formik={formik} disabled={readonly} type="time" placeholder="hh:mm" />
              <Select name={"uitvlieg_jong"} label={"vlogen jonge dieren mee?"} formik={formik} disabled={readonly} lists={settings.lists} />
              <Select name={"uitvlieg_observatie"} label={"zijn alle uitvliegopeningen geobserveerd?"} formik={formik} disabled={readonly} lists={settings.lists} />
              <Text name={"uitvlieg_aantal"} label={"hoeveel uitvliegopeningen zijn geobserveerd?"} formik={formik} disabled={readonly} type="number" />
              <Select name={"uitvlieg_windrichting"} label={"windrichting"} formik={formik} disabled={readonly} lists={settings.lists} />
              <Select name={"uitvlieg_windkracht"} label={"windkracht"} formik={formik} disabled={readonly} lists={settings.lists} />
              <Text name={"uitvlieg_neerslag"} label={"neerslag"} formik={formik} disabled={readonly} type="number" InputProps={{ endAdornment: <InputAdornment position="end">&#13212;</InputAdornment> }} />
              <Text name={"uitvlieg_temperatuur"} label={"temperatuur"} formik={formik} disabled={readonly} type="number" InputProps={{ endAdornment: <InputAdornment position="end">&#8451;</InputAdornment> }} />
            </>
          }
          {formik.values.extraInfo["telmethode"] === "vliegroute" &&
            <>
              <Select name={"vliegroute_middel"} label={"middelen"} formik={formik} disabled={readonly} lists={settings.lists} />
              {formik.values.extraInfo["vliegroute_middel"] === "anders" &&
                <Text name={"vliegroute_middel_anders"} label={"anders"} formik={formik} disabled={readonly} />
              }
              <Text name={"vliegroute_eerste"} label={"tijdstip eerste uitvlieger"} formik={formik} disabled={readonly} type="time" placeholder="hh:mm" />
              <Text name={"vliegroute_laatste"} label={"tijdstip laatste uitvlieger"} formik={formik} disabled={readonly} type="time" placeholder="hh:mm" />
              <Text name={"vliegroute_begintijd"} label={"begintijd"} formik={formik} disabled={readonly} type="time" placeholder="hh:mm" />
              <Text name={"vliegroute_eindtijd"} label={"eindtijd"} formik={formik} disabled={readonly} type="time" placeholder="hh:mm" />
              <Select name={"vliegroute_windrichting"} label={"windrichting"} formik={formik} disabled={readonly} lists={settings.lists} />
              <Select name={"vliegroute_windkracht"} label={"windkracht"} formik={formik} disabled={readonly} lists={settings.lists} />
              <Text name={"vliegroute_neerslag"} label={"neerslag"} formik={formik} disabled={readonly} type="number" InputProps={{ endAdornment: <InputAdornment position="end">&#13212;</InputAdornment> }} />
              <Text name={"vliegroute_temperatuur"} label={"temperatuur"} formik={formik} disabled={readonly} type="number" InputProps={{ endAdornment: <InputAdornment position="end">&#8451;</InputAdornment> }} />
            </>
          }
          {formik.values.extraInfo["telmethode"] === "insitu" &&
            <>
              <Select name={"insitu_middel"} label={"middelen"} formik={formik} disabled={readonly} lists={settings.lists} />
              {formik.values.extraInfo["insitu_middel"] === "anders" &&
                <Text name={"insitu_middel_anders"} label={"anders"} formik={formik} disabled={readonly} />
              }
            </>
          }
          
          <Grid item xs={12}>
            <TextField select disabled={readonly} label="volledigheid" variant="standard" name="extraInfo.volledigheid" fullWidth  {...getErrorProps(formik, "extraInfo.volledigheid")} {...formik.getFieldProps('extraInfo.volledigheid')} >
              {getOptions(settings.lists["volledigheid"])}
            </TextField>
          </Grid>

          {show('volledigheid_opm') &&
            <Grid item xs={12}>
              <TextField disabled={readonly} label="waarom niet geheel geteld?" variant="standard" name="extraInfo.volledigheid_opm" fullWidth  {...getErrorProps(formik, "extraInfo.volledigheid_opm")} {...formik.getFieldProps('extraInfo.volledigheid_opm')} />
            </Grid>
          }

        </>

      }

      <Button variant="outlined" onClick={objectInfo}>Object gegevens...</Button>

      <Grid item xs={12}>
        <Photos
          uploads={formik.values.uploads || []}
          setUploads={(uploads) => formik.setFieldValue('uploads', uploads)}
          readonly={readonly}
          formik={formik}
        />
      </Grid>
      <ObjectDetails formik={formik} readonly={readonly} onClose={() => setOpenObjectInfo(false)} open={openObjectInfo} zomertelling={zomertelling} />
    </Grid>
  )
}

const Select = ({ formik, disabled, label, name, lists, onChange, filter }) => {
  if (!lists[name]) return name;
  return (
    <Grid item xs={12}>
      <TextField
        select
        disabled={disabled}
        label={label}
        variant="standard"
        name={`extraInfo.${name}`}
        fullWidth
        {...getErrorProps(formik, `extraInfo.${name}`)}
        {...formik.getFieldProps(`extraInfo.${name}`)}
        {...onChange && { onChange: onChange }}
      >
        {getOptions(lists[name].filter(item => filter ? filter(item) : true))}
      </TextField>
    </Grid>
  )
}

const Text = ({ formik, disabled, label, name, ...props }) => {
  return (
    <Grid item xs={12}>
      <TextField
        disabled={disabled}
        label={label}
        variant="standard"
        name={`extraInfo.${name}`}
        fullWidth
        {...getErrorProps(formik, `extraInfo.${name}`)}
        {...formik.getFieldProps(`extraInfo.${name}`)}
        {...props}
      >
      </TextField>
    </Grid>
  )
}

export default VisitDetails